import React from 'react';
import './Reference.scss';

function Reference() {
  return (
    <div className="reference">
      {/* <p className="reference__copy">
        <sup className="reference__sup">1</sup> Lorem ipsum dolor sit amet consectetur adipisicing
        elit. Minima dicta, eius temporibus aspernatur quibusdam sint cumque enim consequuntur nihil
        possimus ullam commodi nostrum officia quod, inventore dolor eligendi eum deserunt?
      </p> */}

      <p className="reference__copy">All images provided by Intel Labs.</p>
    </div>
  );
}

export default Reference;
